module.exports = __webpack_public_path__ + "static/media/pageNotFoundImage.b5222e27.png";